<script setup>
import { computed, ref } from 'vue';
import { navItems } from '@/helpers/navigationPanelHelper.js';
import { useNavigationPanelStore } from '@/stores/navigationPanel';
import CreateOrderByImportStep1 from './createByImport/CreateOrderByImportStep1.vue';
import CreateOrderByImportStep2 from './createByImport/CreateOrderByImportStep2.vue';
import WizardComponent from '../utils/WizardComponent.vue';

const navigationPanelStore = useNavigationPanelStore();
const createOrderByImportStep1Ref = ref();
const createOrderByImportStep2Ref = ref();

const attachment5 = ref(null);
const attachment6 = ref(null);

const stepsConfig = computed(() => [
  {
    number: 1,
    header: '1. Import załączników',
    onPreviousAction: null,
    onNextAction: () => {
      attachment5.value = createOrderByImportStep1Ref.value?.attachment5 || null;
      attachment6.value = createOrderByImportStep1Ref.value?.attachment6 || null;
    },
    previousButtonDisabled: true,
    nextButtonDisabled: createOrderByImportStep1Ref.value?.bothAttachmentsUploaded !== true
  },
  {
    number: 2,
    header: '2. Podsumowanie importu',
    onPreviousAction: null,
    onNextAction: null,
    previousButtonDisabled: false,
    nextButtonDisabled: false //TODO to be changed
  }
]);

function onFinished() {
  createOrderByImportStep2Ref.value?.requestFormSubmit();
}

// created
navigationPanelStore.setNavigationPanelItems(navItems.CREATE_ORDER_BY_IMPORT);
</script>

<template>
  <WizardComponent :steps="stepsConfig" :onFinishAction="onFinished" wizardHeaderMaxWidth="600px">
    <template #wizardContent1>
      <CreateOrderByImportStep1 ref="createOrderByImportStep1Ref" />
    </template>
    <template #wizardContent2>
      <CreateOrderByImportStep2
        v-if="attachment5 != null && attachment6 != null"
        ref="createOrderByImportStep2Ref"
        :attachment5="attachment5"
        :attachment6="attachment6"
      />
      <div
        v-else
        style="height: 150px; display: flex; align-items: center; justify-content: center"
      >
        Brak załączników. Coś poszło nie tak. Proszę odświeżyć stronę i spróbować ponownie.
      </div>
    </template>
  </WizardComponent>
</template>

<style scoped></style>
